<template>
  <div class="policy-info">
    <nav-bar titleText="团队政策解读" @goBack="goBack" :isFixed="true" rightSize="13px" ></nav-bar>
    <div class="empty"></div>
    <div class="policy-content">
      <!-- <div class="title">{{policyInfo.title}}</div> -->
      <div class="content" v-html="policyInfo.details"></div>
    </div>
  </div>
</template>

<script>
import navBar from "../components/navBar";
export default {
  data() {
    return {
      policyInfo: {},
    }
  },
  components: {
    navBar
  },
  created() {
    this.getPolicInfo()
  },
  mounted() {

  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getPolicInfo() {
      const param = {
        id: 5                 // 1：解债业务说明，2：债务人说明，3：债权人说明，4：解债经纪人说明，5：团队政策解读
      }
      this.$api.post('debt/member/setting/get-content-setting', param)
      .then((data) => {
        this.policyInfo = data
      })
    }
  }
};
</script>

<style lang="less">
.policy-info {
  padding-top: 88px;
  .empty {
    width: 100%;
    height: 12px;
    background: #F5F6F7;
  }
  .policy-content {
    padding: 10px 12px 0;
    height: 390px;
    font-size: 16px;
    color: #333333;
    line-height: 26px;
  }
}
</style>
